import React, { createContext, useContext, useState, useEffect } from 'react';
import authService from '../services/auth';
import { logInfo, logError } from '../utils/logger';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (authService.isLoggedIn()) {
          setIsAuthenticated(true);
          setUser(authService.getUser());
          logInfo('User authenticated from storage:', authService.getUser().username);
        }
      } catch (error) {
        logError('Error checking authentication:', error);
        authService.logout();
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleAuthCallback = async (code) => {
    setLoading(true);
    setAuthError(null);
    
    try {
      const callbackResult = await authService.handleCallback(code);
	  //if (!callbackResult) throw new Error('Callback failed');
	  if (authService.getUser()) {
        setIsAuthenticated(true);
        setUser(authService.getUser());
        logInfo('User authenticated:', authService.getUser().username);
        return true;
	  } else {
        setIsAuthenticated(false);
        setUser(null);
        logError('Could not get user info:', authService);
        return false;
	  }
    } catch (error) {
      setAuthError(error.message || 'Authentication failed');
      logError('Authentication error:', error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    authService.logout();
    setIsAuthenticated(false);
    setUser(null);
    logInfo('User logged out');
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        loading,
        authError,
        login: () => window.location.href = authService.getAuthUrl(),
        handleAuthCallback,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);